module.exports = __webpack_public_path__ + "static/img/helhdiyim.135a207.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/healthycockpit/helhdiyim.png
// module id = 9rWZ
// module chunks = 5